import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { DocumentType, DocumentUploadPayload } from '@/types'
import { AxiosError } from 'axios'

type Params = DocumentUploadPayload & {
  body: FormData
}

type UploadDocumentResponse = {
  key: string
  original_name: string
  type: DocumentType
}

export async function uploadDocument({ body, ...params }: Params) {
  const response = await httpClient(
    'accounting-dealer',
  ).post<UploadDocumentResponse>('/v3/file/document', body, {
    params,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  return response.data
}

export function useUploadDocument(
  options?: UseMutationOptions<
    UploadDocumentResponse,
    AxiosError,
    Params,
    unknown
  >,
) {
  return useMutation({
    mutationFn: uploadDocument,
    ...options,
  })
}
